module.exports = __webpack_public_path__ + "static/img/rongyu2.8302fff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rongyu2.jpg
// module id = BiU0
// module chunks = 1